import http from "../http";
import api from "../../config/api";
import { FormsResponse } from "../../interfaces/api/form";
import { MainResponse } from "../../interfaces/api/response";

/**
 * Reports API service
 */
const reports = {
  /**
   * Get forms
   * @returns {Promise<FormsResponse>} API response
   */
  getForms: (): Promise<FormsResponse> => http.get(api.forms),
  addReport: (body: any): Promise<MainResponse> =>
    http.post(api.addReport, body),
  /**
   * Update an existing report
   * @param {string} id - Report ID
   * @param {any} body - Report data
   * @returns {Promise<MainResponse>} API response
   */
  updateReport: (id: string, body: any): Promise<MainResponse> =>
    http.post(`${api.getForm}/${id}`, body),
  /**
   * Get reports list for a specific patient
   * @param {number} patientId - Patient ID
   * @returns {Promise<any>} API response
   */
  getReportsByPatient: (patientId: number): Promise<any> =>
    http.get(`${api.addReport}?patient_id=${patientId}`),
  /**
   * Delete a report by ID
   * @param {number|string} id - Report ID
   * @returns {Promise<MainResponse>} API response
   */
  deleteReport: (id: number | string): Promise<MainResponse> =>
    http.post(`${api.removeReport}${id}`, {}),
};

export default reports;
